import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { RmaRequestModel } from 'src/app/shared/models/rma.model';

@Component({
  selector: 'app-review-and-finish-step',
  templateUrl: './review-and-finish-step.component.html',
  styleUrls: ['./review-and-finish-step.component.css']
})
export class ReviewAndFinishStepComponent implements OnInit {
  @Input() rmarequest : RmaRequestModel;
  @Output() onNextStep: EventEmitter<any> = new EventEmitter<any>();
  @Output() onPrevStep: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
  }

  getCustomerString(type)
  {
    return GlobalConstants.getCustomerString(type);
  }

  getRmaTypeString(type)
  {
    return GlobalConstants.getRmaTypeString(type);
  }

  isStockRotation()
  {
    return GlobalConstants.isStockRotationType(this.rmarequest.rma.rmaTypeRequested)
  }


  onFinish()
  {
    this.onNextStep.emit(this.rmarequest);
  }

  onBack()
  {
    this.onPrevStep.emit(this.rmarequest);
  }
}
